import React from "react";

import "./Footer.css";

import { useSelector, useDispatch } from "react-redux";

import {
  languageChange,
  currentSelectedLanguage,
} from "../../../StateManagement/actions";

function Footer(prop) {
  const selectedLanguage = useSelector(currentSelectedLanguage);

  return (
    <div className="container-fluid myfooter">
      <footer
        className={
          (prop.class === undefined ? "" : prop.class) +
          " footer mt-auto bg-lighter"
        }
      >
        <div className="container">
          <p
            className="mb-0"
            style={{ textAlign: "center", fontSize: 0.78 + "rem" }}
          >
            <a
              className="footerLinks"
              href="https://rpost.com/legal-notices/terms-and-conditions/"
            >
              {selectedLanguage.LstLanguageCodes.UI_GeneralTerms}
            </a>
            : {selectedLanguage.LstLanguageCodes.UI_ClickToView}&nbsp;
            <a
              className="footerLinks"
              href="https://rpost.com/legal-notices/legal-and-patent-notice/"
            >
              {selectedLanguage.LstLanguageCodes.UI_PatentTrademark}
            </a>
            , {selectedLanguage.LstLanguageCodes.UI_AndotherlegalServices}
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
